import s from "../partnerPortal.module.css";
import { Panel, SectionTitle } from "./shared";
import { useEffect, useState } from "react";
import {
  partnerGetDashboard,
  partnerGetUsage,
} from "../../../services/partnerCalls";
import { errorHandler } from "../../../utils";
import { DEFAULT_ERROR_MESSAGE } from "../../../constants";
import { Spinner } from "../../../components/UI/Spinner/Spinner";
import { displayRole } from "../partnerRoleCatalog";

const ROLE_COLORS = [
  "#2dd4bf", // teal
  "#3b82f6", // blue
  "#8b5cf6", // purple
  "#ec4899", // pink
  "#f97316", // orange
  "#10b981", // emerald
  "#6366f1", // indigo
  "#f59e0b", // amber
];

export default function Usage() {
  const [usage, setUsage] = useState([]);
  const maxRole =
    usage?.length > 0 ? Math.max(...usage?.map((r) => r?.count || 0)) : 1;
  const [loading, setLoading] = useState(false);

  const fetchUsage = async () => {
    setLoading(true);
    try {
      const res = await partnerGetUsage();
      if (res?.data?.data) {
        setUsage(res.data.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorHandler(error?.response?.data?.message || DEFAULT_ERROR_MESSAGE);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsage();
  }, []);

  return (
    <div>
      <SectionTitle
        title="Usage"
        sub="Tests run and credits consumed over time"
      />

      <Panel>
        <div className={`${s.blockTitle} ${s.pg10}`}>
          Top roles tested
        </div>
        {loading && <Spinner />}

        {usage?.length > 0 &&
          usage?.map((row, idx) => {
            const barColor =
              row?.color || ROLE_COLORS[idx % ROLE_COLORS.length];
            return (
              <div className={s.pg11} key={row?.role || idx}>
                <div className={s.pg12}
                >
                  <span className={s.pg13}>{displayRole(row?.role)}</span>
                  <span className={s.pg14}>{row?.count} tests</span>
                </div>
                <div className={s.trackThin}>
                  <div
                    style={{
                      width: `${(row?.count / maxRole) * 100}%`,
                      height: "100%",
                      background: barColor,
                    }}
                  />
                </div>
              </div>
            );
          })}
      </Panel>
    </div>
  );
}
